// src/frontend/.../Recruitment/validation/section4.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";

export function validateSection4(data = {}) {
  const formData = data || {};
  const newErrors = {};

  // If data is null, all required fields are missing
  if (data === null || data === undefined) {
    newErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section4", newErrors);
    return newErrors;
  }

  // 1) heldDirectorships required
  if (formData.heldDirectorships === null) {
    newErrors.heldDirectorships = "This field is required.";
  }

  // 2) If heldDirectorships === true -> directorshipDetails required + row validation + futureIntentions required
  if (formData.heldDirectorships === true) {
    if (
      formData.directorshipDetails === null ||
      !formData.directorshipDetails ||
      formData.directorshipDetails.length === 0
    ) {
      newErrors.directorshipDetails = "This field is required.";
    }

    (formData.directorshipDetails || []).forEach((entry = {}, index) => {
      if (!entry.nameOfFirm)
        newErrors[`nameOfFirm_${index}`] = "This field is required.";
      if (!entry.natureOfBusiness)
        newErrors[`natureOfBusiness_${index}`] = "This field is required.";
      if (!entry.countryIncorporationStarted)
        newErrors[`countryIncorporationStarted_${index}`] =
          "This field is required.";

      // EXACT: if timeSpent is empty AND no endDate -> error
      if ((entry.timeSpent || "").trim() === "" && !entry.endDate) {
        newErrors[`timeSpent_${index}`] = "This field is required.";
      }

      if (!entry.startDate)
        newErrors[`startDate_${index}`] = "This field is required.";
    });

    if (formData.futureIntentions === null) {
      newErrors.futureIntentions = "This field is required.";
    }
    // 3) If futureIntentions === false -> ifNoDetails required
    if (
      formData.futureIntentions === false &&
      (formData.ifNoDetails || "").trim() === ""
    ) {
      newErrors.ifNoDetails = "This field is required.";
    }
  }

  // 4) If futureIntentions === true -> ifYesDetails required
  if (
    formData.futureIntentions === true &&
    (formData.ifYesDetails || "").trim() === ""
  ) {
    newErrors.ifYesDetails = "This field is required.";
  }

  // 5) financialLiabilities required
  if (formData.financialLiabilities === null) {
    newErrors.financialLiabilities = "This field is required.";
  }

  // 6) If financialLiabilities === true -> additionalInformation required
  if (
    formData.financialLiabilities === true &&
    (formData.additionalInformation || "").trim() === ""
  ) {
    newErrors.additionalInformation = "This field is required.";
  }

  // Set errors in tracker
  errorTrackerV2.setSectionErrors("section4", newErrors);
  // console.log("validateSection4 - Errors:", newErrors);

  return {
    ...newErrors,
    _isValid: Object.keys(newErrors).length === 0,
  };
}
